import React from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
const PropertyItem = ({ property, listView = false }) => {
  const { name, slug, address, images, created_at, cliff, notes } = property;
  return (
    <div className="property-container">
      <div className={listView ? "feat_property list" : "feat_property"}>
        <div className="thumb">
          <Link to={`${slug}`}>
            <img className="img-whp" src={images} alt={name} />
          </Link>
        </div>
        <div className="details">
          <div className="tc_content">
            <Link to={`${slug}`}>
              <h4>{name}</h4>
            </Link>
            <p>
              <span className="flaticon-placeholder"></span> {address}
            </p>
            <p className="property-description">{notes}</p>
          </div>
          <div className="fp_footer">
            <ul className="fp_meta float-left mb0">
              <li className="list-inline-item">
                <Link>
                  <img
                    src={cliff.photo ? cliff.photo : "assets/img/pposter1.png"}
                    alt=""
                  />
                </Link>
              </li>
              <li className="list-inline-item">
                <Link>{cliff.name.split(" ").slice(0, 2).join(" ")}</Link>
              </li>
            </ul>
            <div className="fp_pdate float-right">
              {format(new Date(created_at), "dd MMM, Y")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyItem;
